import { colors } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderLeft = styled('div')({
  display: 'flex',
  alignItems: 'baseline',
  gap: 8,
  flexWrap: 'wrap',
});

export const CurrentPrice = styled('span')(({ theme }) => ({
  fontSize: '1.4rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
  lineHeight: 1,
}));

export const ChangeLabel = styled('span', {
  shouldForwardProp: prop => prop !== 'positive',
})<{ positive: boolean }>(({ positive }) => ({
  fontSize: '0.82rem',
  fontWeight: 600,
  color: positive ? colors.green[700] : colors.red[700],
}));

export const PeriodControls = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  '& .MuiToggleButton-root': {
    fontSize: '0.72rem',
    padding: '2px 10px',
    textTransform: 'none',
    fontWeight: 600,
  },
  '& .MuiToggleButton-root.Mui-selected': {
    backgroundColor: '#1976d2',
    color: '#fff',
    '&:hover': { backgroundColor: '#1565c0' },
  },
});

export const Subtitle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  marginTop: theme.spacing(0.25),
  marginBottom: theme.spacing(1.5),
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
}));

export const StatBar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  gap: 0,
  marginTop: theme.spacing(1.5),
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  paddingTop: theme.spacing(1.5),
}));

export const StatItem = styled('div')(({ theme }) => ({
  flex: 1,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  borderRight: `1px solid ${theme.palette.grey[200]}`,
  '&:first-of-type': { paddingLeft: 0 },
  '&:last-of-type': { borderRight: 'none' },
}));

export const StatLabel = styled('div')(({ theme }) => ({
  fontSize: '0.68rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  marginBottom: 2,
}));

export const StatValue = styled('div')(({ theme }) => ({
  fontSize: '0.9rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const RobustnessRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

export const SeriesToggleRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.75),
  marginBottom: theme.spacing(1),
}));

export const TabRow = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  paddingBottom: theme.spacing(0.5),
}));

export const TabButton = styled('button')<{ active?: boolean }>(({ theme, active }) => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  fontSize: '0.8rem',
  fontWeight: active ? 700 : 400,
  color: active ? theme.palette.primary.main : theme.palette.text.secondary,
  borderBottom: active ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
  marginBottom: '-1px',
  transition: 'color 0.15s, border-color 0.15s',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

export const TableSectionLabel = styled('div')(({ theme }) => ({
  fontSize: '0.7rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '&:first-of-type': { marginTop: theme.spacing(1) },
}));

export const TxTable = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '0.8rem',
  marginTop: theme.spacing(1),
}));

export const TxTableRow = styled('tr')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '&:last-child': { borderBottom: 'none' },
}));

export const TxTableHead = styled('th')<{ align?: 'left' | 'right' | 'center' }>(({ theme, align = 'left' }) => ({
  padding: `${theme.spacing(0.75)} ${theme.spacing(1)}`,
  textAlign: align,
  fontWeight: 700,
  fontSize: '0.7rem',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  borderBottom: `2px solid ${theme.palette.grey[200]}`,
}));

export const TxTableCell = styled('td')<{ align?: 'left' | 'right' | 'center' }>(({ theme, align = 'left' }) => ({
  padding: `${theme.spacing(0.75)} ${theme.spacing(1)}`,
  textAlign: align,
  color: theme.palette.text.primary,
  verticalAlign: 'middle',
}));
